module.exports = __webpack_public_path__ + "static/media/cat3.fbb67549.jpg";